import { Space } from 'antd';
import React, { useEffect } from 'react';
import { useModel, SelectLang } from '@umijs/max';
import Avatar from './AvatarDropdown';
import styles from './index.less';
import { getToken, setToken } from '@/utils/token';
import { parseInt } from 'lodash';
import moment from 'moment';
import { refreshToken } from '@/services/tconnect/auth';

export type SiderTheme = 'light' | 'dark';

const GlobalHeaderRight: React.FC = () => {
  const { initialState } = useModel('@@initialState');

  useEffect(() => {
    const i = setInterval(async () => {
      if (REACT_APP_ENV === 'dev') {
        return;
      }
      const auth = getToken();

      if (auth.expiresAt) {
        const time = parseInt(`${auth.expiresAt}000`);
        const timeExpiresAt = moment(time);
        if (timeExpiresAt < moment()) {
          try {
            const auth = getToken();
            const data = await refreshToken({
              refreshToken: auth.refreshToken,
            });
            if (data.refreshToken && data.accessToken) {
              setToken(data);
            }
          } catch (e) {}
        }
      }
    }, 30000);
    return () => clearInterval(i);
  }, []);

  if (!initialState || !initialState.settings) {
    return null;
  }

  const { navTheme, layout } = initialState.settings;
  let className = styles.right;

  if ((navTheme === 'dark' && layout === 'top') || layout === 'mix') {
    className = `${styles.right}  ${styles.dark}`;
  }

  return (
    <Space className={className}>
      <Avatar menu />
      <SelectLang className={styles.action} />
    </Space>
  );
};
export default GlobalHeaderRight;
